
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUserSettings as ObiUserSettingsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-user-settings.js';
 
 
 

 
 export const ObiUserSettings = createComponent({
   react: React,
   tagName: 'obi-user-settings',
   elementClass: ObiUserSettingsElement,
   events: {
     
   }
  });
 
 